import { createSelector } from 'reselect'

import { selectLandingCategories } from 'partner360/features/landing'
import { getCount } from 'partner360/features/landing/helpers/getCount'
import { LandingStatus } from 'partner360/models/landing/LandingStatus'

import { selectLandingState } from './selectLandingState'

export const selectPartnersCountInCategory = createSelector(
  [selectLandingState, selectLandingCategories],
  ({ processedPlannings, selectedPlanning }, categories) => {
    return categories.map((category) => {
      const categoryData = selectedPlanning.AllCategories.find((el) => el.Category === category)
      const offeringsForCategory = categoryData
        ? categoryData.Offerings.map((el) => el.Offering)
        : []
      const filtered = processedPlannings.filter(
        (el) =>
          el.planningId === selectedPlanning.PlanningId &&
          el.category === category &&
          offeringsForCategory.includes(el.offering)
      )

      return {
        category,
        allCounts: getCount(filtered),
        completedCount: getCount(
          filtered.filter(
            (el) =>
              el.status === LandingStatus.Acknowledged ||
              el.status === LandingStatus.NotApplicable ||
              el.status === LandingStatus.Reviewed
          )
        ),
      }
    })
  }
)
